import React, {useContext, useEffect, useState} from 'react';
//imports
import '../../styles/NavBar.css';
import {useNavigate} from "react-router-dom";
import {AuthContext} from "../../config/AuthContext";
import {Menu} from "antd";
import {BsHouse, BsPerson, BsPower, BsToggleOff} from "react-icons/bs";
import Colors from "../../styles/Colors";
import {defaultMenu} from "../../model/root/Menu";

const NavBarInscripcions = () => {
    const navigate = useNavigate();
    const {isLoggedIn, userId, user, actualSite, setActualSite} = useContext(AuthContext);
    const [current, setCurrent] = useState('mail');
    const [currentMenu, setCurrentMenu] = useState([]);



    const homeItem = {
        key: 'home',
        label: 'INSCRIPCIONS',
        icon: <BsHouse />
    };


    useEffect(() => {
        user.menus && user.menus.map(value => (
            value && value.menu && value.pantalla &&
            value.pantalla === actualSite && setCurrentMenu(value.menu)
        ));

    }, []);

    const isItemInArrayHome = user.menus.some((value) =>
        value.menu && value.pantalla === actualSite && value.menu.some((item) => item.key === homeItem.key)
    );

    if (!isItemInArrayHome) {
        currentMenu.push(homeItem);
    }

    const onClick = (e) => {
    };

    return <Menu style={{backgroundColor: Colors.colors.color2, color: Colors.colors.color6}}
                 onClick={onClick} selectedKeys={[current]} mode="horizontal" items={currentMenu} />;

};

export default NavBarInscripcions;
